/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_No_WeatherInputs */

const en_ui_color_by_reason_no_weather = /** @type {(inputs: Ui_Color_By_Reason_No_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No weather data`)
};

const de_ui_color_by_reason_no_weather = /** @type {(inputs: Ui_Color_By_Reason_No_WeatherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Wetterdaten`)
};

/**
* | output |
* | --- |
* | "No weather data" |
*
* @param {Ui_Color_By_Reason_No_WeatherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_no_weather = /** @type {((inputs?: Ui_Color_By_Reason_No_WeatherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_No_WeatherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_no_weather(inputs)
	return de_ui_color_by_reason_no_weather(inputs)
});